(() => {
  document.querySelectorAll('.fp-picker').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const data = JSON.parse(root.querySelector('[data-picker-data]').textContent);
    const t=data.i18n;
    const label=value=>value==='No Scripture'?t.logoOnly:(t.labels?.[value]||value);
    const products = data.products.filter(p => p.id && p.variants.length);
    const rows = products.flatMap(p => p.variants.map(v => ({...v,logo:p.logo,scripture:p.scripture,product:p})));
    const fields = Object.fromEntries(['logo','color','scripture','size'].map(k => [k,root.querySelector('[data-choice="'+k+'"]')]));
    const photo=root.querySelector('[data-photo]'), gallery=root.querySelector('[data-gallery]');
    const price=root.querySelector('[data-price]'), status=root.querySelector('[data-status]');
    const id=root.querySelector('[data-variant]'), add=root.querySelector('[data-add]'), confirm=root.querySelector('[data-confirm]');
    let selected=null, galleryKey='';
    const initialProduct=products.find(p=>p.id===data.initialProductId)||products[0];
    const initialVariant=initialProduct?.variants.find(v=>String(v.id)===new URL(window.location.href).searchParams.get('variant'));
    const confirmedSize=root.querySelector('[data-confirm-size]'),confirmedVariant=root.querySelector('[data-confirm-variant]');
    function syncConfirmation(){confirmedSize.disabled=confirmedVariant.disabled=!confirm.checked||!selected;confirmedSize.value=selected?.size||'';confirmedVariant.value=selected?String(selected.id):'';}
    const unique = (rs,k)=>[...new Set(rs.map(r=>r[k]))];
    const setOptions=(k,values,preferred,placeholder)=>{
      fields[k].replaceChildren();
      if(placeholder) fields[k].add(new Option(placeholder,''));
      values.forEach(value=>fields[k].add(new Option(label(value),value)));
      fields[k].value=values.includes(preferred)?preferred:(placeholder?'':values[0]||'');
      fields[k].disabled=!values.length;
    };
    const showImage=(src,alt)=>{if(src){photo.src=src;photo.alt=alt;photo.hidden=false;}else{photo.removeAttribute('src');photo.alt=t.imageUnavailable;photo.hidden=true;}};
    function render(changed) {
      const previous=Object.fromEntries(Object.entries(fields).map(([k,el])=>[k,el.value]));
      if(!changed&&initialProduct){previous.logo=initialProduct.logo;previous.scripture=initialProduct.scripture;previous.color=initialVariant?.color||initialProduct.variants[0]?.color;previous.size=initialVariant?.size||'';}
      setOptions('logo',unique(rows,'logo'),previous.logo);
      let eligible=rows.filter(r=>r.logo===fields.logo.value);
      setOptions('color',unique(eligible,'color'),previous.color);
      eligible=eligible.filter(r=>r.color===fields.color.value);
      setOptions('scripture',unique(eligible,'scripture'),previous.scripture);
      eligible=eligible.filter(r=>r.scripture===fields.scripture.value);
      setOptions('size',unique(eligible,'size'),previous.size,t.chooseSize);
      selected=eligible.find(r=>r.size===fields.size.value)||null;
      if(changed) confirm.checked=false;
      syncConfirmation();
      const display=selected||eligible[0];
      const prices=eligible.map(r=>r.price);
      price.textContent=display?new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:data.currency}).format((selected?selected.price:Math.min(...prices))/100):t.unavailable;
      id.disabled=!selected||!selected.available;
      id.value=selected?String(selected.id):'';
      add.disabled=!selected||!selected.available||!confirm.checked;
      add.textContent=selected&&!selected.available?t.soldOut:t.add;
      status.textContent=!selected?t.chooseSize:selected.available?fields.logo.value+' · '+label(fields.color.value)+' · '+label(fields.scripture.value)+' · '+fields.size.value:t.soldOut;
      if(!display){gallery.replaceChildren();showImage(null,'');return;}
      root.querySelector('[data-description]').innerHTML=display.product.description;
      const destination=new URL(window.location.href);destination.pathname=display.product.url;destination.searchParams.set('variant',display.id);window.history.replaceState({},'',destination.pathname+destination.search+window.location.hash);
      const key=display.product.id+':'+display.color;
      if(galleryKey!==key){
        galleryKey=key;
        gallery.replaceChildren();
        let images=display.product.images.filter(im=>im.variants.some(vid=>display.product.variants.some(v=>v.id===vid&&v.color===display.color))||(im.alt||'').toLowerCase().includes(display.color.toLowerCase()));
        if(!images.length && display.image) images=[{src:display.image,alt:display.product.title+' · '+display.color}];
        const seenImages = new Set();
        images = images.filter(im => {
          const key = / — (front view|back view|flat lay|hanging view)$/.test(im.alt || '') ? im.alt : im.src;
          if (seenImages.has(key)) return false;
          seenImages.add(key);
          return true;
        });
        images.forEach((im,index)=>{
          const button=document.createElement('button');button.type='button';button.setAttribute('aria-label',t.image+' '+label(fields.scripture.value)+' '+label(display.color)+' '+(index+1));
          const image=document.createElement('img');image.src=im.src;image.alt=im.alt;image.loading='lazy';button.append(image);
          button.addEventListener('click',()=>showImage(im.src,im.alt));gallery.append(button);
        });
        showImage(display.image||images[0]?.src,display.product.title+' · '+display.color);
      }
    }
    Object.entries(fields).forEach(([k,el])=>el.addEventListener('change',()=>render(k)));
    confirm.addEventListener('change',()=>{syncConfirmation();add.disabled=!selected||!selected.available||!confirm.checked;});
    root.querySelector('form').addEventListener('submit',event=>{
      if(!selected||!selected.available||!confirm.checked||id.value!==String(selected.id)){event.preventDefault();status.textContent=t.invalid;}
    });
    render();
  });
})();
